export default () => ({
    heading: false,
    intersect() {
        this.heading = true
    },
    get headingClass() {
        return this.heading ? 'visible' : ''
    }
})

export const latestNews = () => ({
    visible: false,
    intersect() {
        this.visible = true
    },
    get latestClass() {
        return this.visible ? 'visible' : ''
    }
})